import { ITripPlanner } from '../types/plannerTypes'

export enum ConflictType {
    overlap = 1,
    lunchBreak = 2,
    shiftEnd = 3,
    wrongAcuity = 4,
    Allow=5,
    Reschedule=6
}

export interface ConflictDialogData {
    conflictType: ConflictType,
    tripPlanner?: ITripPlanner
}

export interface IntervalNumbers {
    start: number,
    end: number
}